/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Lexique_Review_ValveInputs */



/**
* | output |
* | --- |
* | "Check head presence / restart if needed" |
*
* @param {Intervention_Plan_Pdf_Lexique_Review_ValveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_lexique_review_valve = /** @type {((inputs?: Intervention_Plan_Pdf_Lexique_Review_ValveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Lexique_Review_ValveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Check head presence / restart if needed")
	return /** @type {LocalizedString} */ ("Vérification de la présence de la tête installation / redémarrage si nécessaire")
});